import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faArrowRight, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal } from '../../shared'

interface Competitor {
    id: number
    name: string
}

@Component({
    templateUrl: './pre-bid-competitors.component.html',
    standalone: true,
    imports: [CommonModule, FormsModule, FaIconComponent, WjInputModule],
})
export class PreBidCompetitorsComponent extends BaseModal implements OnInit {
    faArrowRight = faArrowRight
    faArrowLeft = faArrowLeft
    faSpinner = faSpinner

    bidOutlookId!: string
    bidDescription!: string
    allCompetitors: Competitor[] = []
    selectedCompetitorIds: number[] = []

    ngOnInit(): void {
        // Ensure selectedCompetitorIds is initialized
        if (!this.selectedCompetitorIds) {
            this.selectedCompetitorIds = []
        }
        // Filter competitors into available and selected
        this.updateLists()
    }

    availableCompetitors: Competitor[] = []
    selectedCompetitors: Competitor[] = []
    availableSearch = ''
    selectedSearch = ''


    updateLists() {
        // Available competitors are those not in selectedCompetitorIds
        this.availableCompetitors = this.allCompetitors.filter(
            c => !this.selectedCompetitorIds.includes(c.id),
        )
        // Selected competitors are those in selectedCompetitorIds
        this.selectedCompetitors = this.allCompetitors.filter(c => this.selectedCompetitorIds.includes(c.id))

        // Apply search filters
        this.filterAvailable()
        this.filterSelected()
    }

    filterAvailable() {
        if (this.availableSearch === '') {
            this.availableCompetitors = this.allCompetitors.filter(c => !this.selectedCompetitorIds.includes(c.id))
        } else {
            const searchLower = this.availableSearch.toLowerCase()
            this.availableCompetitors = this.allCompetitors.filter(
                c => !this.selectedCompetitorIds.includes(c.id) && c.name.toLowerCase().includes(searchLower),
            )
        }
    }

    filterSelected() {
        if (this.selectedSearch === '') {
            this.selectedCompetitors = this.allCompetitors.filter(c => this.selectedCompetitorIds.includes(c.id))
        } else {
            const searchLower = this.selectedSearch.toLowerCase()
            this.selectedCompetitors = this.allCompetitors.filter(
                c => this.selectedCompetitorIds.includes(c.id) && c.name.toLowerCase().includes(searchLower),
            )
        }
    }

    moveToSelected(competitor: Competitor) {
        if (!this.selectedCompetitorIds.includes(competitor.id)) {
            this.selectedCompetitorIds.push(competitor.id)
            this.updateLists()
        }
    }

    moveToAvailable(competitor: Competitor) {
        const index = this.selectedCompetitorIds.indexOf(competitor.id)
        if (index > -1) {
            this.selectedCompetitorIds.splice(index, 1)
            this.updateLists()
        }
    }

    moveAllToAvailable() {
        this.selectedCompetitors.forEach(c => {
            const index = this.selectedCompetitorIds.indexOf(c.id)
            if (index > -1) {
                this.selectedCompetitorIds.splice(index, 1)
            }
        })
        this.updateLists()
    }

    onAvailableDoubleClick(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const competitor = this.allCompetitors.find(c => c.id === +selectedValue)
            if (competitor) {
                this.moveToSelected(competitor)
            }
        }
    }

    onSelectedDoubleClick(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const competitor = this.allCompetitors.find(c => c.id === +selectedValue)
            if (competitor) {
                this.moveToAvailable(competitor)
            }
        }
    }

    moveSelectedToRight(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const competitor = this.allCompetitors.find(c => c.id === +selectedValue)
            if (competitor) {
                this.moveToSelected(competitor)
            }
        }
    }

    moveSelectedToLeft(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const competitor = this.allCompetitors.find(c => c.id === +selectedValue)
            if (competitor) {
                this.moveToAvailable(competitor)
            }
        }
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        // Save the selected competitor IDs
        this.services.data
            .put('api/BidOutlook/UpdatePreBidCompetitors', {
                bidOutlookId: this.bidOutlookId,
                competitorIds: this.selectedCompetitorIds,
            })
            .subscribe({
                next: () => {
                    resolveSave()
                },
                error: errorResult => {
                    this.services.notification.error('Failed to save pre-bid competitors')
                    rejectSave(errorResult)
                },
            })
    }
}

